import { SCROLL_TO_TOP, RESET_SCROLL } from "./scrollAction";

const initialState = {
  shouldScrollToTop: false,
};

const scrollReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCROLL_TO_TOP:
      return {
        ...state,
        shouldScrollToTop: true,
      };
    case RESET_SCROLL:
      return {
        ...state,
        shouldScrollToTop: false,
      };
    default:
      return state;
  }
};

export default scrollReducer;
